import { render, staticRenderFns } from "./GenerarReportes.vue?vue&type=template&id=65aa41ac"
import script from "./GenerarReportes.vue?vue&type=script&lang=js"
export * from "./GenerarReportes.vue?vue&type=script&lang=js"
import style0 from "./GenerarReportes.vue?vue&type=style&index=0&id=65aa41ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VContainer,VDivider,VIcon})
